import Vue from "vue";
import Vuex from "vuex";

import formModule from "../../../Breeze.FormBuilder.Frontend/store/modules/form";
import documentModule from "../../../Breeze.FormBuilder.Frontend/store/modules/document";
import formGroupModule from "../../../Breeze.FormBuilder.Frontend/store/modules/formGroup";
import documentGroupModule from "../../../Breeze.FormBuilder.Frontend/store/modules/documentGroup";
import layoutStore from "./modules/layout";
import episodeOfCareModule from "./modules/episodeOfCare";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions: {},
  modules: {
    formBuilder: formModule,
    formSubmitter: documentModule,
    formGroup: formGroupModule,
    formGroupSubmitter: documentGroupModule,
    layout: layoutStore,
    client: episodeOfCareModule
  }
});
